// extracted by mini-css-extract-plugin
export default {"root":"home_root__6hTBL","logo":"home_logo__HMu75","betaLogologo":"home_betaLogologo__SXGPv","subTitle":"home_subTitle__tqP3j","newLine":"home_newLine__hG-nr"};